import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  src?: string;
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export function Avatar({ name, src, className, ...rest }: AvatarProps) {
  return (
    <div
      className={cn(styles.avatar, className)}
      aria-label={name}
      {...rest}
    >
      {src ? (
        <img className={styles.avatarImg} src={src} alt="" />
      ) : (
        initials(name)
      )}
    </div>
  );
}
